export default {
    print(dom, css,isTest) {
        let oldFrame = document.getElementsByClassName('print-frame');
        if (oldFrame.length > 0) {
            oldFrame[0].parentNode.removeChild(oldFrame[0]);
        }
        try {
            let printIframe = document.createElement('iframe');
            document.body.appendChild(printIframe);
            printIframe.style.position = 'absolute';
            printIframe.style.border = '0';
            printIframe.style.width = '0';
            printIframe.style.height = '0';
            printIframe.style.left = '0';
            printIframe.style.top = '0';
            printIframe.style.zIndex = '-1';
            if(isTest){
                printIframe.style.width = '100%';
                printIframe.style.height = '100%';
                printIframe.style.zIndex = '10000';
                printIframe.style.background = '#fff';
            }
            printIframe.className = 'print-frame';
            let printWindow = printIframe.contentWindow;
            let printDoc = printIframe.contentDocument ? printIframe.contentDocument : (printIframe.contentWindow ? printIframe.contentWindow.document : printIframe.document);
            printDoc.open();
            printDoc.write(`${this.getHead(css)}${this.getBody(dom)}`);
            printDoc.close();
            let timeoutId = setTimeout(() => {
                printWindow.focus();
                printWindow.print();
            }, 500);
        } catch (e) {
            throw e + ". iframes may not be supported in this browser.";
        }
    },
    getHead( css) {
        let links = '';
        let stylecss = `<style type="text/css">${css}</style>`;
        return `<head><title></title>${links}${stylecss}</head>`;
    },

    getBody(dom) {
        // 打印内容
        const printHtml = document.getElementById(dom);
        let html = '';
        if (printHtml) {
            html = printHtml.outerHTML;
        } else {
            throw 'The attribute printHTM is not entered!';
        }
        return `<body>${html}</body>`;
    }
}


// WEBPACK FOOTER //
// ./src/utils/print.js